import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ClientApiKeyApi, ClientApiKeyDto } from "api";

const clientApiKeyApi = new ClientApiKeyApi();

export interface ClientApiKeyState {
  key: ClientApiKeyDto | null;
}

const initialState: ClientApiKeyState = {
  key: null,
};

export const getClientApiKey = createAsyncThunk<ClientApiKeyDto | null>(
  "clientApiKey/get",
  async () => {
    const { data } = await clientApiKeyApi.apiClientApiKeyGet();
    return data;
  }
);

export const createClientApiKey = createAsyncThunk<ClientApiKeyDto>(
  "clientApiKey/create",
  async () => {
    const { data } = await clientApiKeyApi.apiClientApiKeyPost();
    return data;
  }
);

export const updateClientApiKey = createAsyncThunk<ClientApiKeyDto>(
  "clientApiKey/update",
  async () => {
    const { data } = await clientApiKeyApi.apiClientApiKeyPut();
    return data;
  }
);

export const deleteClientApiKey = createAsyncThunk<void>(
  "clientApiKey/delete",
  async () => {
    await clientApiKeyApi.apiClientApiKeyDelete();
  }
);

const clientApiKeySlice = createSlice({
  name: "clientApiKey",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getClientApiKey.fulfilled, (state, action) => {
      state.key = action.payload;
    });
    builder.addCase(createClientApiKey.fulfilled, (state, action) => {
      state.key = action.payload;
    });
    builder.addCase(updateClientApiKey.fulfilled, (state, action) => {
      state.key = action.payload;
    });
    builder.addCase(deleteClientApiKey.fulfilled, (state) => {
      state.key = null;
    });
  },
});

export default clientApiKeySlice.reducer;
